import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import Login from './pages/Login';
import Admin from './pages/Admin';
import JobForm from './pages/JobForm';
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import CookiePolicy from './pages/CookiePolicy';
import Eures from './pages/Eures';
import ContentEditor from './pages/ContentEditor';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="contact" element={<Contact />} />
            <Route path="jobs" element={<Jobs />} />
            <Route path="job/:slug" element={<JobDetail />} />
            <Route path="eures" element={<Eures />} />
            <Route path="aviso-legal" element={<LegalNotice />} />
            <Route path="politica-de-privacidad" element={<PrivacyPolicy />} />
            <Route path="terminos-y-condiciones" element={<TermsConditions />} />
            <Route path="politica-de-cookies" element={<CookiePolicy />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Layout />}>
            <Route path="admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="admin/job/:id" element={<ProtectedRoute><JobForm /></ProtectedRoute>} />
            <Route path="admin/content/:pageSlug" element={<ProtectedRoute><ContentEditor /></ProtectedRoute>} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
